type LocalTranslationType = { [i18n: string]: { [key: string]: string } };

const localTranslation: LocalTranslationType = {
    de: {
        // General translations
        'errors.no_connection': 'Bitte überprüfen Sie Ihre Netzwerkverbindung!',
        'errors.retry': 'Erneut versuchen',
        'static.settings.lang.en-DE': 'Englisch',
        'static.settings.lang.de-DE': 'Deutsch',
        'static.settings.lang.fr-FR': 'Französisch',
        'cookie.consent.allow': 'Alles klar!',
        'cookie.consent.deny': 'Nein danke',
        'cookie.consent.text':
            'Das Q.Live speichert zur ordnungsgemäßen Funktion Cookies.',

        'actions.refresh': 'Aktualisieren',
        'messages.is_reloading': 'Wird aktualisiert...',

        // General form translations
        'form.general.back': 'Zurück',
        'form.general.not_blank': 'Dieses Feld sollte nicht leer sein',
        'form.general.no_email':
            'Es wurde keine gültige E-Mail Adresse erkannt',

        // Login
        'static.login.title': 'Einloggen',
        'static.login.form.username': 'E-Mail',
        'static.login.form.username_placeholder': 'E-Mail eingeben',
        'static.login.form.password': 'Passwort',
        'static.login.form.password_placeholder': 'Passwort eingeben',
        'static.login.form.stay_logged_in': 'Angemeldet bleiben',
        'static.login.form.password_reset': 'Passwort vergessen?',
        'static.login.form.login': 'Einloggen',

        // Reset password
        'static.reset.title': 'Passwort zurücksetzen',
        'static.reset.form.username': 'E-Mail',
        'static.reset.form.username_placeholder': 'E-Mail eingeben',
        'static.reset.form.reset': 'Zurücksetzen',

        'status.on': 'Aktiviert',
        'status.off': 'Deaktiviert',
    },
    en: {
        // General translations
        'errors.no_connection': 'Please check your network connection!',
        'errors.retry': 'Retry',
        'static.settings.lang.en-DE': 'English',
        'static.settings.lang.de-DE': 'German',
        'static.settings.lang.fr-FR': 'French',
        'cookie.consent.allow': 'I accept',
        'cookie.consent.deny': 'No thanks',
        'cookie.consent.text':
            'Q.Live must save cookies for functional purposes',

        'actions.refresh': 'Reload',
        'messages.is_reloading': 'Is reloading...',

        // General form translations
        'form.general.back': 'Back',
        'form.general.not_blank': 'This field should not be blank',
        'form.general.no_email': 'No valid email was recognized',

        // Login
        'static.login.title': 'Log in',
        'static.login.form.username': 'Email',
        'static.login.form.username_placeholder': 'Enter email',
        'static.login.form.password': 'Password',
        'static.login.form.password_placeholder': 'Enter password',
        'static.login.form.stay_logged_in': 'Stay logged in',
        'static.login.form.password_reset': 'Forgotten your password?',
        'static.login.form.login': 'Log in',

        // Reset password
        'static.reset.title': 'Reset password',
        'static.reset.form.username': 'Email',
        'static.reset.form.username_placeholder': 'Enter email',
        'static.reset.form.reset': 'Reset',

        'status.on': 'Activated',
        'status.off': 'Deactivated',
    },
};

export default localTranslation;
